// tslint:disable-next-line:no-shadowed-variable
import { ConfigModel } from '../core/interfaces/config';

// tslint:disable-next-line:no-shadowed-variable
export class MenuConfig implements ConfigModel {
	public config: any = {};

	constructor() {
		this.config = {
			header: {
				self: {},
				items: [
					{
					}]
				},
			aside: {
				self: {},
				items: [
						{
						title: 'Dashboard',
						page: '/'
					},
					{section: 'Inbound'},
				
					{
						title: 'Yard management',
						root: true,
						bullet: 'dot',
						icon: '	flaticon-truck',
						submenu: [
							// {
							// 	title: 'Dashboard',
							// 	page: '/yardadministration'
							// },
							// {
							// 	title: 'Yard Designer',
							// 	page: '/yarddesigner'
							// },
							{
								title: 'Yard map',
								page: '/yardadministration'
							},
							{
								title: 'Reports',
								page: '/yardmanagement/yardreports'
							}
						]
					},
					// {
					// 	title: 'Yard Administration',
					// 	root: true,
					// 	bullet: 'dot',
					// 	icon: '	fa fa-tachometer-alt',
					// 	page: '/yardadministration'
					// },
					// {
					// 	title: 'Inventory',
					// 	root: true,
					// 	bullet: 'dot',
					// 	icon: 'fa fa-user-check',
					// 	submenu: [
					// 		{
					// 			title: 'Yard Inventory',
					// 			page: '/inventory/yards'
					// 		},
					// 		{
					// 			title: 'Aduasis Inventory',
					// 			page: '/inventory/aduasis'
					// 		}
					// 	]
					// },
					{
						title: 'Unload',
						root: true,
						bullet: 'dot',
						icon: 'fa fa-truck-loading',
						submenu: [
							// {
							// 	title: 'Dashboard',
							// 	page: '/unloads/dashboard'
							// },
							{
								title: 'Unload shipment',
								page: '/unloads/catalog'
							}
						
							
						
						]
					},
					{
						title: 'EXL audit',
						root: true,
						bullet: 'dot',
						icon: 'fa fa-user-check',
						submenu: [
							{
								title: 'LTL shipments',
								page: '/revision/ltl'
							},
							{
								title: 'FTL shipments',
								page: '/revision/direct'
							},
							
						]
					},
					{section: 'Inventory'},
					{
						title: 'Inventory',
						bullet: 'dot',
						icon: 'flaticon-box-1',
						root: true,
						submenu: [
							// {
							// 	title: 'Dashboard',
							// 	page: '/inbounds'
							// },
							{
								title: 'Inventory on hand',
								page: '/inbounds',
								queryParams:{status:"onhand"}
							}
						
						]
					},
					// {
					// 	title: 'User Management',
					// 	root: true,
					// 	bullet: 'dot',
					// 	icon: 'flaticon-user',
					// 	page: '/user-management'
					// },
					// {
					// 	title: 'Audit Log',
					// 	root: true,
					// 	bullet: 'dot',
					// 	icon: 'flaticon-interface-5',
					// 	page: '/audit-log'
					// },
					{section: 'OUTBOUND'},
				
					{
						title: 'Load sheet',
						root: true,
						bullet: 'dot',
						icon: '	fa fa-th',
						submenu: [
							// {
							// 	title: 'Dashboard',
							// 	page: '/outbounds'
							// },
							// {
							// 	title: 'Load orders',
							// 	page: '/loadorders'
							// },
							{
								title: 'Load sheet',
								page: '/loadorders/loadordersslam'
							},
						]
					},
					{
						title: 'Labels',
						root: true,
						bullet: 'dot',
						icon: '	fa fa-th',
						submenu: [
							// {
							// 	title: 'Dashboard',
							// 	page: '/outbounds'
							// },
							// {
							// 	title: 'Load orders',
							// 	page: '/loadorders'
							// },
							{
								title: 'Labels',
								page: '/labels'
							},
						]
					},
				
					{section: 'ELECTRONIC AUDIT'},
					{
						title: 'AUDITORIA CAT SLP',
						root: true,
						bullet: 'dot',
						icon: '	fa fa-th',
						submenu: [
							{
								title: 'Audit report',
								page: '/auditreport'
							}
						]
					},
				
					// {section: 'SETTINGS'},
					// {
					// 	title: 'Settings',
					// 	bullet: 'dot',
					// 	icon: 'flaticon-cogwheel',
					// 	root: true,
					// 	submenu: [
							
					// 	]
					// }
					
				]
			}
		};
	}
}
